export default __webpack_public_path__ + "static/kombi-ddef633ca880cbc366eb8f3cb1c56030.svg";